<template>
    <div class="flex gap:8">
        <span :key="num" v-for="num in max">
            <img alt="" :src="`${prefix}image/star_${value >= num ? 'on' : 'off'}.svg`" />
        </span>
    </div>
</template>

<script setup>
    const prefix = inject("prefix");

    defineProps({
        max: { default: 5, type: Number },
        value: { required: true, type: Number }
    });
</script>
